import { useEffect } from 'react';
import { useFeatureFlags } from './useFeatureFlags';
import { flagsmithFeatureFlags } from '@/lib/flagsmith';

/**
 * Resolves the `alerts_ide_column` flag for the three IDE/Platform column
 * surfaces (org alerts table, user dashboard alerts table, AlertOccurrencesPanel).
 *
 * Hides the column while flags are loading. This matches the production
 * default (flag off) so prod users never see the column flash in and
 * disappear; staging users tolerate a brief load-hidden state before the
 * column resolves to visible.
 *
 * Fails closed on `isError` — returns `false` even if `flags[KEY]` carries a
 * stale `true` from a previous successful fetch (React Query keeps last-good
 * data on a failing refetch). The error log lives inside a `useEffect` so it
 * fires once per error transition rather than on every component render.
 */
export function useAlertsIdeColumnEnabled(): boolean {
  const { flags, isLoading, isError } = useFeatureFlags([
    flagsmithFeatureFlags.ALERTS_IDE_COLUMN,
  ]);

  useEffect(() => {
    if (isError) {
      console.error(
        '[useAlertsIdeColumnEnabled] Failed to resolve alerts_ide_column feature flag; defaulting to off'
      );
    }
  }, [isError]);

  if (isLoading || isError) {
    return false;
  }
  return flags[flagsmithFeatureFlags.ALERTS_IDE_COLUMN] === true;
}
